/* TS Combos: practice + race, category + daily and merch combos. Layouts: split, addon, grid. */
(function () {
  'use strict';

  var SIZE_RE = /(\d{3})\s*\/\s*(\d{2})\s*Z?R\s*(\d{2})/i;

  function normSize(s) {
    var m = SIZE_RE.exec(s || '');
    return m ? m[1] + '/' + m[2] + 'R' + m[3] : null;
  }
  function money(c) {
    var d = Math.round(c) / 100;
    return '$' + d.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Category keys: lower case, letters/numbers only, so "Off-road", "offroad" and "Off road" all match
  function segKey(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function segList(s) { return String(s || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  function shortName(p) {
    return String(p.title || '').replace(/^(Accelera|Armstrong|MRF|Zeetex|GT Radial)\s+/i, '').replace(/\s*\(.*?\)\s*$/, '');
  }

  /* ---------- product helpers ---------- */

  function prep(p) {
    if (!p || p._prepped) return p;
    p._prepped = true;
    p.optNames = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    p.sizeIdx = -1;
    p.sideIdx = -1;
    p.optNames.forEach(function (n, i) { if (/^side$/i.test(n)) p.sideIdx = i; });
    for (var i = 0; i < p.optNames.length; i++) {
      if (i === p.sideIdx) continue;
      var hit = p.variants.some(function (v) { return SIZE_RE.test(v.options[i]); });
      if (hit) { p.sizeIdx = i; break; }
    }
    p.variants.forEach(function (v) {
      v.size = p.sizeIdx > -1 ? normSize(v.options[p.sizeIdx]) : null;
      v.sizeLabel = p.sizeIdx > -1 ? v.options[p.sizeIdx] : '';
    });
    p.isTire = p.sizeIdx > -1;
    return p;
  }

  // Best variant among candidates for a selection map {optionIndex: value}
  function resolve(p, list, sel) {
    var out = list.slice();
    for (var i = 0; i < p.optNames.length; i++) {
      if (i === p.sideIdx || sel[i] == null) continue;
      var f = out.filter(function (v) { return v.options[i] === sel[i]; });
      if (f.length) out = f;
    }
    if (p.sideIdx > -1) {
      var left = out.filter(function (v) { return /left/i.test(v.options[p.sideIdx]); });
      if (left.length) out = left;
    }
    return out[0] || null;
  }

  function uniq(arr) {
    var seen = {}, out = [];
    arr.forEach(function (x) { if (!seen[x]) { seen[x] = 1; out.push(x); } });
    return out;
  }

  // Lines to add for a product/variant/qty. Splits Left/Right for directional rally tires.
  function linesFor(p, v, qty) {
    if (!v) return [];
    if (p.sideIdx > -1 && qty >= 2) {
      var other = p.variants.filter(function (x) {
        return x !== v && x.available && x.options.every(function (o, i) {
          return i === p.sideIdx ? o !== v.options[i] : o === v.options[i];
        });
      })[0];
      if (other) {
        var l = /left/i.test(v.options[p.sideIdx]) ? v : other;
        var r = l === v ? other : v;
        return [{ p: p, v: l, q: Math.ceil(qty / 2) }, { p: p, v: r, q: Math.floor(qty / 2) }];
      }
    }
    return [{ p: p, v: v, q: qty }];
  }

  // Full price = compare-at price if higher than the current price, else the current price
  function fullPrice(v) { return Math.max(v.price, v.compare || 0); }
  // Combo price per unit for the discounted item: the day's price (or full price less the minimum discount, if lower), then the extra combo %
  function comboUnit(v, pct, min) {
    var base = Math.min(v.price, fullPrice(v) * (1 - (min || 0) / 100));
    return base * (1 - (pct || 0) / 100);
  }

  /* ---------- main product form (PDP) ---------- */

  function mainForm() {
    return document.querySelector('.product-form-block.buy-buttons form.js-product-form') ||
      document.querySelector('.product-info form.js-product-form');
  }
  function mainVariantId() {
    var f = mainForm();
    var s = f && f.querySelector('[name="id"]');
    if (s && s.value) return parseInt(s.value, 10);
    var m = /[?&]variant=(\d+)/.exec(location.search);
    return m ? parseInt(m[1], 10) : null;
  }

  // Switch the product page's own size picker (theme listens for change on .product-form__single-selector)
  function pickMainSize(label) {
    var sels = document.querySelectorAll('.product-info .product-form__single-selector');
    for (var i = 0; i < sels.length; i++) {
      var s = sels[i];
      var hit = Array.prototype.filter.call(s.options, function (o) { return o.value === label; })[0];
      if (!hit) continue;
      s.value = label;
      if (window.jQuery) window.jQuery(s).trigger('change');
      else s.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  }

  /* ---------- cart ---------- */

  function addLines(lines, title, done) {
    var items = lines.filter(function (l) { return l.q > 0; }).map(function (l) {
      return { id: l.v.id, quantity: l.q, properties: { _combo: title } };
    });
    var lac = window.liquidAjaxCart;
    var lacAdd = lac && (typeof lac.add === 'function' ? lac.add : (typeof lac.cartRequestAdd === 'function' ? lac.cartRequestAdd : null));
    if (lacAdd) {
      var finished = false;
      var onEnd = function (e) {
        var rs = e.detail && e.detail.requestState;
        if (!rs || rs.requestType !== 'add') return;
        finished = true;
        document.removeEventListener('liquid-ajax-cart:request-end', onEnd);
        var ok = rs.responseData && rs.responseData.ok;
        done(!!ok, ok ? null : (rs.responseData && rs.responseData.body && rs.responseData.body.description));
      };
      document.addEventListener('liquid-ajax-cart:request-end', onEnd);
      lacAdd.call(lac, { items: items });
      setTimeout(function () { if (!finished) { document.removeEventListener('liquid-ajax-cart:request-end', onEnd); done(true); } }, 8000);
      return;
    }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok) { window.location.href = '/cart'; } else { done(false, res.j && res.j.description); }
      })
      .catch(function () { done(false); });
  }

  /* ---------- combo model ---------- */

  function Combo(d, ctx) {
    this.d = d;
    this.ctx = ctx;
    prep(d.a);
    prep(d.b);
    var cur = ctx.current;
    if (cur && d.b && d.b.id === cur && !d.anyA) {
      this.driver = d.b; this.follower = d.a;
    } else {
      this.driver = d.a; this.follower = d.b;
    }
    this.onPdp = !!cur && this.driver && this.driver.id === cur;
    // Merch combo on a non-product page: the first set is "any tire set", so only the merch is added
    this.anyTire = !!(d.a && d.a.any);
    this.segs = segList(d.seg).map(segKey);
    this.selD = {};
    this.selF = {};
    this.userPickedF = false;
  }

  Combo.prototype.followerCandidates = function (dv) {
    var f = this.follower, match = this.d.match && f.isTire && this.driver.isTire;
    return f.variants.filter(function (v) {
      return v.available && (!match || !dv || v.size === dv.size);
    });
  };

  Combo.prototype.driverCandidates = function () {
    var self = this, f = this.follower, match = this.d.match && f.isTire && this.driver.isTire;
    return this.driver.variants.filter(function (v) {
      if (!v.available) return false;
      if (!match) return true;
      return f.variants.some(function (x) { return x.available && x.size === v.size; });
    });
  };

  Combo.prototype.state = function () {
    var D = this.driver, F = this.follower, dv;
    var match = this.d.match && F.isTire && D.isTire;
    if (this.onPdp) {
      var id = this.ctx.mainVariantId();
      dv = D.variants.filter(function (v) { return v.id === id; })[0] || D.variants.filter(function (v) { return v.available; })[0];
    } else {
      dv = resolve(D, this.driverCandidates(), this.selD);
      if (dv) { var sd = this.selD; dv.options.forEach(function (o, i) { sd[i] = o; }); }
    }
    var fc = this.followerCandidates(dv);
    if (!this.userPickedF && dv && F.sizeIdx > -1 && !match) {
      var same = fc.filter(function (v) { return v.size === dv.size; })[0];
      if (same) this.selF[F.sizeIdx] = same.options[F.sizeIdx];
    }
    var fv = resolve(F, fc, this.selF);
    if (fv) { var sf = this.selF; fv.options.forEach(function (o, i) { sf[i] = o; }); }

    var qD = this.driver === this.d.a ? this.d.a.qty : this.d.b.qty;
    var qF = this.follower === this.d.a ? this.d.a.qty : this.d.b.qty;
    var target = this.d.target === 'b' ? this.d.b : this.d.a;
    var pct = this.d.pct || 0, min = this.d.min || 0;

    var lines = [];
    if (dv && dv.available) lines = lines.concat(linesFor(D, dv, qD));
    if (fv) lines = lines.concat(linesFor(F, fv, qF));

    var full = 0, save = 0;
    lines.forEach(function (l) {
      var t = l.v.price * l.q;
      full += t;
      if (l.p === target && (pct || min)) save += (l.v.price - comboUnit(l.v, pct, min)) * l.q;
    });

    var thr = this.ctx.threshold, low = null;
    lines.forEach(function (l) {
      if (l.p.isTire && l.v.inv != null && l.v.inv > 0 && l.v.inv <= thr && (!low || l.v.inv < low.v.inv)) low = l;
    });

    return {
      dv: dv, fv: fv, fc: fc, match: match, qD: qD, qF: qF, lines: lines,
      full: full, save: Math.round(save), total: full - Math.round(save),
      target: target, pct: pct, min: min, low: low,
      anyTire: this.anyTire,
      ok: !!(fv && (this.anyTire || (dv && dv.available)))
    };
  };

  /* ---------- rendering pieces ---------- */

  function optionSelects(p, list, sel, opts) {
    var html = '';
    p.optNames.forEach(function (name, i) {
      if (i === p.sideIdx) return;
      if (opts.skipSize && i === p.sizeIdx) return;
      var vals = uniq(list.map(function (v) { return v.options[i]; }));
      if (vals.length < 2) return;
      html += '<label class="tsc-field"><span class="tsc-field__label">' + esc(i === p.sizeIdx ? 'Size' : name) + '</span>' +
        '<select class="tsc-select" data-tsc-opt="' + opts.who + '" data-idx="' + i + '">' +
        vals.map(function (v) { return '<option value="' + esc(v) + '"' + (sel[i] === v ? ' selected' : '') + '>' + esc(v) + '</option>'; }).join('') +
        '</select></label>';
    });
    return html;
  }

  function sideNote(p, lines) {
    if (p.sideIdx < 0) return '';
    var mine = lines.filter(function (l) { return l.p === p; });
    if (mine.length < 2) return '';
    return mine.map(function (l) { return l.q + ' ' + esc(l.v.options[p.sideIdx]); }).join(' + ');
  }

  function effPct(v, st) { return Math.round((1 - comboUnit(v, st.pct, st.min) / v.price) * 100); }
  function unitLine(p, v, st) {
    if (!v) return '';
    var isT = st.target === p && (st.pct || st.min);
    var now = isT ? comboUnit(v, st.pct, st.min) : v.price;
    var free = isT && now <= 0;
    var per = p.isTire ? ' <small>/ tire</small>' : '';
    return '<div class="tsc-price">' +
      (free ? '<span class="tsc-price__now">FREE</span>' : '<span class="tsc-price__now">' + money(now) + per + '</span>') +
      (isT ? ' <s class="tsc-price__was">' + money(v.price) + '</s><span class="tsc-pill">' + (free ? 'Free with set' : effPct(v, st) + '% off in combo') + '</span>' : '') +
      '</div>';
  }

  function tile(c, p, st) {
    var isD = p === c.driver;
    var v = isD ? st.dv : st.fv;
    var q = isD ? st.qD : st.qF;
    var spec = '', sel = '';
    if (isD && c.anyTire) {
      return '<div class="tsc-tile tsc-tile--driver tsc-tile--any">' +
        '<p class="tsc-role">' + esc(p.role || 'Your tires') + '</p>' +
        '<div class="tsc-tile__img tsc-tile__img--any" aria-hidden="true"><span>Any tire set</span></div>' +
        '<p class="tsc-name"><a href="' + esc(p.url) + '">Any tire set</a></p>' +
        '<p class="tsc-spec">Add tires to your cart to unlock this deal.</p>' +
        '<a class="tsc-shop" href="' + esc(p.url) + '">Shop tires &rarr;</a>' +
        '</div>';
    }
    if (isD && c.onPdp) {
      spec = q + ' &times; ' + esc(v ? (v.sizeLabel || v.title) : '') + (c.d.anyA ? '' : ' <span class="tsc-muted">&middot; your selection</span>');
    } else if (isD) {
      sel = optionSelects(p, c.driverCandidates(), c.selD, { who: 'd' });
      spec = q + ' &times; ' + esc(v ? (v.sizeLabel || v.title) : '');
    } else {
      sel = optionSelects(p, p.variants.filter(function (x) { return x.available && (!st.match || !st.dv || x.size === st.dv.size); }), c.selF, { who: 'f', skipSize: st.match });
      if (!v) {
        var alt = st.match ? uniq(c.driverCandidates().map(function (x) { return x.sizeLabel; })) : [];
        spec = '<span class="tsc-warn">Not in stock in ' + esc(st.dv ? st.dv.sizeLabel : 'this size') + '</span>' +
          (alt.length ? '<span class="tsc-alt">This combo is available in ' + alt.slice(0, 8).map(function (a) {
            return c.onPdp ? '<button type="button" class="tsc-size" data-tsc-size="' + esc(a) + '">' + esc(a) + '</button>' : esc(a);
          }).join(c.onPdp ? ' ' : ', ') + '</span>' : '');
      } else {
        spec = (!p.isTire && v.title === 'Default Title' ? 'Qty ' + q : q + ' &times; ' + esc(p.isTire ? v.sizeLabel : v.title)) + (st.match ? ' <span class="tsc-chip">Size matched</span>' : '');
      }
    }
    var side = sideNote(p, st.lines);
    var name = c.d.anyA && isD ? 'Your tire set' : shortName(p);
    return '<div class="tsc-tile' + (isD ? ' tsc-tile--driver' : '') + '">' +
      '<p class="tsc-role">' + esc(p.role || '') + '</p>' +
      '<div class="tsc-tile__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
      '<p class="tsc-name"><a href="' + esc(p.url) + '">' + esc(name) + '</a></p>' +
      '<p class="tsc-spec">' + spec + '</p>' +
      (side ? '<p class="tsc-muted tsc-side">' + side + '</p>' : '') +
      sel +
      unitLine(p, v, st) +
      '</div>';
  }

  function lowStock(st) {
    if (!st.low) return '';
    var l = st.low;
    var label = l.p.isTire ? l.v.sizeLabel : shortName(l.p);
    return '<p class="tsc-scarce"><span class="tsc-dot"></span>Only ' + l.v.inv + ' left in ' + esc(shortName(l.p)) + (l.p.isTire ? ' ' + esc(label) : '') + '</p>';
  }

  function totals(st) {
    if (!st.ok) return '<div class="tsc-total"><span class="tsc-total__label">Pick a size that works for both sets</span></div>';
    var n = st.lines.reduce(function (a, l) { return a + l.q; }, 0);
    return '<div class="tsc-total">' +
      '<span class="tsc-total__label">' + (st.anyTire ? 'Price with any tire set' : 'Combo total &middot; ' + n + ' items') + '</span>' +
      '<span class="tsc-total__row"><span class="tsc-total__now">' + money(st.total) + '</span>' +
      (st.save > 0 ? '<s class="tsc-total__was">' + money(st.full) + '</s><span class="tsc-save">You save ' + money(st.save) + '</span>' : '') +
      '</span></div>';
  }

  /* ---------- layouts ---------- */

  function renderCard(c, ctx, compact) {
    var st = c.state();
    var a = c.d.a, b = c.d.b;
    var tiles = tile(c, a, st) + '<div class="tsc-plus" aria-hidden="true">+</div>' + tile(c, b, st);
    return '<article class="tsc-card' + (compact ? ' tsc-card--compact' : '') + '" data-combo="' + esc(c.d.id) + '">' +
      '<div class="tsc-card__top">' +
      (c.d.tab ? '<span class="tsc-tag">' + esc(c.d.tab) + '</span>' : '') +
      '<h3 class="tsc-title">' + esc(String(c.d.title || '').replace(/^[A-Z]{2}-\d{2}:\s*/, '')) + '</h3>' +
      (c.d.pitch ? '<p class="tsc-pitch">' + esc(c.d.pitch) + '</p>' : '') +
      '</div>' +
      '<div class="tsc-pair">' + tiles + '</div>' +
      '<div class="tsc-foot">' + totals(st) + lowStock(st) +
      '<button type="button" class="button button--green button--fill tsc-cta" data-tsc-add' + (st.ok ? '' : ' disabled') + '>' +
      esc(!st.ok ? 'Not available in this size' : c.anyTire ? (st.total <= 0 ? 'Add to cart — free' : 'Add to cart — ' + money(st.total)) : ctx.cta + ' — ' + money(st.total)) + '</button>' +
      (c.anyTire ? '<p class="tsc-note">' + (st.total <= 0 ? 'Free when your cart has a tire set.' : 'Deal price applies when your cart has a tire set.') + '</p>' : (ctx.note ? '<p class="tsc-note">' + esc(ctx.note) + '</p>' : '')) +
      '<p class="tsc-msg" role="status" aria-live="polite"></p>' +
      '</div></article>';
  }

  function renderAddonRow(c, ctx) {
    var st = c.state();
    var F = c.follower, fv = st.fv;
    if (!fv || !st.dv) return '';
    var fl = st.lines.filter(function (l) { return l.p === F; });
    var fFull = fl.reduce(function (a, l) { return a + l.v.price * l.q; }, 0);
    var fTargetSave = F === st.target ? Math.round(fl.reduce(function (a, l) { return a + (l.v.price - comboUnit(l.v, st.pct, st.min)) * l.q; }, 0)) : 0;
    var label = (F.isTire ? 'Add ' + st.qF + '&times; ' + esc(shortName(F)) + ' ' + esc(fv.sizeLabel) : 'Add ' + esc(shortName(F)));
    var priceHtml = fTargetSave >= fFull && fFull > 0 ? '<b>FREE</b> <s>' + money(fFull) + '</s>' :
      '<b>' + money(fFull - fTargetSave) + '</b>' + (fTargetSave ? ' <s>' + money(fFull) + '</s>' : '');
    var unlock = '';
    if (st.target !== F && (st.pct || st.min) && st.dv) unlock = '<span class="tsc-row__unlock">Unlocks ' + effPct(st.dv, st) + '% off your ' + esc(shortName(st.target)) + ' set</span>';
    var sel = optionSelects(F, st.fc, c.selF, { who: 'f', skipSize: st.match });
    var checked = ctx.checked[c.d.id] ? ' checked' : '';
    var side = sideNote(F, st.lines);
    return '<div class="tsc-row' + (checked ? ' is-on' : '') + '" data-combo="' + esc(c.d.id) + '">' +
      '<label class="tsc-row__main"><input type="checkbox" class="tsc-row__check" data-tsc-check' + checked + '>' +
      '<span class="tsc-row__img">' + (F.image ? '<img src="' + esc(F.image) + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="tsc-row__body">' +
      '<span class="tsc-row__tag">' + esc(c.d.tab || F.role || '') + '</span>' +
      '<span class="tsc-row__name">' + label + (st.match ? ' <span class="tsc-chip">Size matched</span>' : '') + '</span>' +
      (side ? '<span class="tsc-muted tsc-side">' + side + '</span>' : '') +
      '<span class="tsc-row__price">' + priceHtml + (fTargetSave && fTargetSave < fFull ? ' <span class="tsc-pill">' + effPct(fv, st) + '% off</span>' : '') + '</span>' +
      unlock + (st.low && st.low.p === F ? lowStock(st) : '') +
      '</span></label>' +
      (sel ? '<div class="tsc-row__opts">' + sel + '</div>' : '') +
      '</div>';
  }

  /* ---------- section controller ---------- */

  function Section(root) {
    var self = this;
    this.root = root;
    this.style = root.getAttribute('data-style') || 'split';
    this.ctx = {
      current: parseInt(root.getAttribute('data-current'), 10) || null,
      threshold: parseInt(root.getAttribute('data-threshold'), 10) || 0,
      cta: root.getAttribute('data-cta') || 'Add both sets',
      note: root.getAttribute('data-note') || '',
      addonTitle: root.getAttribute('data-addon-title') || 'Complete the set',
      filters: segList(root.getAttribute('data-filters')),
      filterLabel: root.getAttribute('data-filter-label') || 'Shop combos for',
      filterAll: root.getAttribute('data-filter-all') || 'All combos',
      mainVariantId: mainVariantId,
      checked: {}
    };
    this.combos = [];
    root.querySelectorAll('script[data-tsc-combo]').forEach(function (s) {
      try {
        var d = JSON.parse(s.textContent);
        if (d && d.a && d.b) self.combos.push(new Combo(d, self.ctx));
      } catch (e) { if (window.console) console.warn('TS Combos: bad combo JSON', e); }
    });
    this.mount = root.querySelector('[data-tsc-mount]');
    this.active = 0;
    // Category from the link, e.g. ?category=drift (so ads and emails can link straight to one category)
    var m = /[?&]category=([^&#]+)/.exec(location.search);
    this.filter = m ? segKey(decodeURIComponent(m[1])) : '';
    var known = this.ctx.filters.map(segKey);
    if (known.indexOf(this.filter) < 0) this.filter = '';
    if (!this.combos.length) { root.style.display = 'none'; return; }

    if (this.style === 'addon') this.placeAddon();
    if (this.ctx.current && this.style === 'split') {
      for (var i = 0; i < this.combos.length; i++) { if (this.combos[i].state().ok) { this.active = i; break; } }
    }
    this.render();
    this.bind();
    if (this.ctx.current) this.watchVariant();
  }

  Section.prototype.placeAddon = function () {
    var anchor = document.querySelector('.product-form-block.buy-buttons');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(this.root, anchor);
      this.root.classList.add('tsc--inbox');
    }
  };

  Section.prototype.render = function () {
    var self = this, ctx = this.ctx, html = '';
    if (this.style === 'grid') {
      var f = this.filter;
      var shown = this.combos.filter(function (c) { return !f || c.segs.indexOf(f) > -1; });
      if (ctx.filters.length) {
        html += '<div class="tsc-filter"><label class="tsc-filter__label" for="' + esc(this.root.id) + '-filter">' + esc(ctx.filterLabel) + '</label>' +
          '<select class="tsc-select tsc-filter__select" id="' + esc(this.root.id) + '-filter" data-tsc-filter>' +
          '<option value="">' + esc(ctx.filterAll) + '</option>' +
          ctx.filters.map(function (name) { var k = segKey(name); return '<option value="' + esc(k) + '"' + (k === f ? ' selected' : '') + '>' + esc(name) + '</option>'; }).join('') +
          '</select><span class="tsc-filter__count" role="status">' + shown.length + (shown.length === 1 ? ' combo' : ' combos') + '</span></div>';
      }
      html += shown.length ? '<div class="tsc-grid">' + shown.map(function (c) { return renderCard(c, ctx, true); }).join('') + '</div>' :
        '<p class="tsc-empty">No combos in this category yet.</p>';
    } else if (this.style === 'addon') {
      var rows = this.combos.map(function (c) { return renderAddonRow(c, ctx); }).join('');
      if (!rows) { this.mount.innerHTML = ''; this.root.style.display = 'none'; return; }
      this.root.style.display = '';
      html = '<div class="tsc-addons"><p class="tsc-addons__title">' + esc(ctx.addonTitle) + '</p>' + rows +
        '<p class="tsc-addons__hint">Checked items are added to cart with your tires.' + (ctx.note ? ' ' + esc(ctx.note) : '') + '</p></div>';
    } else {
      if (this.active >= this.combos.length) this.active = 0;
      if (this.combos.length > 1) {
        html += '<div class="tsc-tabs" role="tablist">' + this.combos.map(function (c, i) {
          return '<button type="button" role="tab" class="tsc-tab' + (i === self.active ? ' is-active' : '') + '" aria-selected="' + (i === self.active) + '" data-tsc-tab="' + i + '">' + esc(c.d.tab || c.d.title) + '</button>';
        }).join('') + '</div>';
      }
      html += renderCard(this.combos[this.active], ctx, false);
    }
    this.mount.innerHTML = html;
  };

  Section.prototype.comboById = function (id) {
    return this.combos.filter(function (c) { return c.d.id === id; })[0];
  };

  Section.prototype.bind = function () {
    var self = this;
    this.mount.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tsc-tab]');
      if (tab) { self.active = parseInt(tab.getAttribute('data-tsc-tab'), 10); self.render(); return; }
      var sz = e.target.closest('[data-tsc-size]');
      if (sz) { pickMainSize(sz.getAttribute('data-tsc-size')); return; }
      var btn = e.target.closest('[data-tsc-add]');
      if (btn) {
        var card = btn.closest('[data-combo]');
        var c = self.comboById(card.getAttribute('data-combo'));
        var st = c.state();
        if (!st.ok) return;
        var msg = card.querySelector('.tsc-msg');
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        addLines(st.lines, c.d.title, function (ok, err) {
          btn.disabled = false;
          btn.textContent = ok ? 'Added ✓' : label;
          if (msg) msg.textContent = ok ? '' : (err || 'Could not add to cart. Please try again.');
          if (ok) setTimeout(function () { btn.textContent = label; }, 2500);
        });
      }
    });
    this.mount.addEventListener('change', function (e) {
      var el = e.target;
      if (el.matches('[data-tsc-filter]')) {
        self.filter = el.value;
        try {
          var u = new URL(location.href);
          if (el.value) u.searchParams.set('category', el.value); else u.searchParams.delete('category');
          history.replaceState(null, '', u.toString());
        } catch (err) {}
        self.render();
        var again = self.mount.querySelector('[data-tsc-filter]');
        if (again) again.focus();
        return;
      }
      var holder = el.closest('[data-combo]');
      if (!holder) return;
      var c = self.comboById(holder.getAttribute('data-combo'));
      if (el.matches('[data-tsc-check]')) {
        self.ctx.checked[c.d.id] = el.checked;
        holder.classList.toggle('is-on', el.checked);
        return;
      }
      if (el.matches('[data-tsc-opt]')) {
        var idx = parseInt(el.getAttribute('data-idx'), 10);
        if (el.getAttribute('data-tsc-opt') === 'd') {
          c.selD[idx] = el.value;
        } else {
          c.selF[idx] = el.value;
          c.userPickedF = true;
        }
        self.render();
      }
    });
    if (this.style === 'addon') this.interceptMainForm();
  };

  Section.prototype.watchVariant = function () {
    var self = this, last = mainVariantId();
    var check = function () {
      var now = mainVariantId();
      if (now !== last) { last = now; self.render(); }
    };
    setInterval(check, 400);
    if (window.jQuery) window.jQuery(document.body).on('variant_changed', function () { setTimeout(check, 30); });
  };

  // Layout B: when add-ons are checked, the main Add to cart adds tires + add-ons in one request.
  Section.prototype.interceptMainForm = function () {
    var self = this;
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form.js-product-form')) return;
      var picked = self.combos.filter(function (c) { return self.ctx.checked[c.d.id]; });
      if (!picked.length) return;
      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      var vid = idEl ? parseInt(idEl.value, 10) : null;
      if (!vid) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var qty = Math.max(1, parseInt(qtyEl ? qtyEl.value : '1', 10) || 1);
      var lines = [{ p: picked[0].driver, v: { id: vid }, q: qty }];
      picked.forEach(function (c) {
        var st = c.state();
        st.lines.forEach(function (l) { if (l.p === c.follower) lines.push(l); });
      });
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; }
      addLines(lines, picked.map(function (c) { return c.d.title; }).join(' | '), function (ok, err) {
        if (btn) { btn.disabled = false; btn.innerHTML = label; }
        if (!ok) {
          var box = form.querySelector('[data-ajax-cart-errors]');
          if (box) box.textContent = err || 'Could not add to cart. Please try again.';
        }
      });
    }, true);
  };

  function init() {
    document.querySelectorAll('[data-tsc]').forEach(function (root) {
      if (root._tsc) return;
      root._tsc = new Section(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
